import { Image as ImageIcon } from 'lucide-react';

import { isChatImageLinkExpired } from './timeline-content';

type Attachment = { url: string; uploadedAt?: string };

const timeLabelFor = (uploadedAt?: string): string =>
  uploadedAt
    ? new Date(uploadedAt).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })
    : '';

export const TimelineAttachments = ({ attachments }: { attachments: Attachment[] }) => {
  if (attachments.length === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {attachments.map((attachment) => {
        const timeLabel = timeLabelFor(attachment.uploadedAt);

        if (isChatImageLinkExpired(attachment.uploadedAt)) {
          return (
            <span
              key={attachment.url}
              className="inline-flex items-center gap-1 rounded-full bg-gray-400/30 px-2.5 py-1 text-xs font-medium text-gray-600"
            >
              <ImageIcon className="h-3.5 w-3.5" />
              Bild raderad{timeLabel ? ` (${timeLabel})` : ''}
            </span>
          );
        }

        return (
          <a
            key={attachment.url}
            href={attachment.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 rounded-full bg-blue-500/40 px-2.5 py-1 text-xs font-medium underline-offset-2 hover:underline"
          >
            <ImageIcon className="h-3.5 w-3.5" />
            Visa bild{timeLabel ? ` (${timeLabel})` : ''}
          </a>
        );
      })}
    </div>
  );
};
